/**
 * familyKeepsake.js — capture the current viewport as a PNG and POST
 * it to /api/family-journey/keepsake so Michael has a private gallery
 * of every completed session.
 *
 * Best-effort: any failure (html2canvas throwing, network error,
 * server 500) is swallowed. This runs at the peak of the healing
 * session and MUST NOT interrupt the experience.
 */
import html2canvas from "html2canvas";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * @param {{ recipient: string, page: 'spine'|'heart', voice_id: string, speaker_name?: string }} meta
 */
export async function captureAndSendKeepsake(meta) {
  try {
    if (!meta || !meta.recipient || !meta.page || !meta.voice_id) return;
    const canvas = await html2canvas(document.body, {
      backgroundColor: "#000",
      logging: false,
      useCORS: true,
      // Scale down a touch — a full retina snapshot balloons the
      // payload and Michael only needs to recognise the shape.
      scale: Math.min(1, window.devicePixelRatio || 1),
    });
    const dataUrl = canvas.toDataURL("image/png");
    // Belt-and-braces: skip absurdly large payloads
    if (dataUrl.length > 6 * 1024 * 1024) return;
    fetch(`${API}/api/family-journey/keepsake`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        recipient:      meta.recipient,
        page:           meta.page,
        voice_id:       meta.voice_id,
        speaker_name:   meta.speaker_name || "",
        image_data_url: dataUrl,
      }),
    }).catch(() => { /* swallow */ });
  } catch (_) { /* noop */ }
}
